import React from 'react'
import {actionsType} from 'config/constants'
import Drawer from 'components/Drawers/Drawer'
import PaymentMethod from './PaymentMethod'
import style from './style.scss'//NOSONAR

const DrawerPaymentMethod = () => {
    return (
        <Drawer
            customClass="drawer-payment-method"
            actionOpen={actionsType.DRAWER.PAYMENT_METHOD_OPEN}
            actionClose={actionsType.DRAWER.PAYMENT_METHOD_CLOSE}>
            <PaymentMethod />
        </Drawer>
    )
}

export default DrawerPaymentMethod
